import { createSelector } from 'reselect';

import { WallpaperCategory } from '@wetransfer/transfer/component/TransferCustomizationProvider/types';
import {
  normalizeChannelWallpaper,
  normalizeWallpaper,
} from '@wetransfer/transfer/component/TransferCustomizationProvider/utils';
import { TransferAmplitudeEventProperties } from '@wetransfer/transfer/modules/analytics/AnalyticsTypes';
import { selectCustomWallpaper } from '@wetransfer/transfer/store/customWallpapers';

import { selectAccountWallpapers } from './account';
import { selectChannelWallpapers } from './channel';

export const selectTransferAmplitudeEventWallpaperProperties = createSelector(
  selectCustomWallpaper,
  selectChannelWallpapers,
  selectAccountWallpapers,
  (
    customWallpaper,
    channelWallpapers,
    accountWallpapers
  ): TransferAmplitudeEventProperties => {
    const wallpapers = customWallpaper
      ? [customWallpaper]
      : channelWallpapers.length
      ? channelWallpapers.map(normalizeChannelWallpaper)
      : accountWallpapers.map(normalizeWallpaper);

    const wallpaperFileType =
      wallpapers
        .map((wallpaper) => wallpaper.extension)
        .sort()
        .filter(Boolean)
        .join(', ')
        .toUpperCase() || undefined;

    const category = wallpapers[0]?.category;

    const wallpaperType =
      category === WallpaperCategory.BRANDED
        ? 'Branded'
        : category === WallpaperCategory.CURATED
        ? 'Gallery'
        : category === WallpaperCategory.CUSTOM
        ? 'Custom'
        : undefined;

    const wallpaperSource = wallpapers.length
      ? customWallpaper
        ? 'Transfer Window'
        : 'Branding Panel'
      : undefined;

    const wallpaperNumber = wallpapers.length || undefined;

    const properties: TransferAmplitudeEventProperties = {
      wallpaperType,
      wallpaperFileType,
      wallpaperNumber,
      wallpaperSource,
    };

    return properties;
  }
);
